module.exports = __webpack_public_path__ + "static/media/gwt_image_presentation.231b42a9.png";